module.exports = __webpack_public_path__ + "img/status-page-secton-main.214bb30d.png";